import { useEffect, useState, useRef, useCallback} from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import StripeCardDetailsModalWrapper from "../../utils/cardDetailsDialog";
import { Box } from "@mui/system";
import { Button, Grid, TextField, Typography } from "@mui/material";
import axios from 'axios';
import { createSeller, editSeller } from "../../redux/action-creators/sellerAction";
import { GooglePlacesDetail } from "../../redux/action-creators/profileAction";
import ClipLoader from "react-spinners/ClipLoader";
import LeftSidebar from "../../components/sidebars/LeftSidebar";
import RightSidebar from "../../components/sidebars/RightSidebar";

import { isEmpty } from "../../utils/helper";
import { toast } from "../../utils/toastsMessage";
import { locationPrediction, RoutingLinks } from "../../utils/constants";

import { ICreateSellerProfile } from "../../interfaceModules/IUserInterface";
import { createSellerProfileValidationSchema } from "../../utils/validationSchema";

import { UserCommonStyles } from "../../styles/CommonStyles";

import { yupResolver } from "@hookform/resolvers/yup";
import { ActionType } from "../../redux/action-types";
import SocialIconSection from "../../components/sidebars/SocialIconSection";

const EditSeller = (props: RouteComponentProps) => {
  const { t: translation } = useTranslation();
  const commonStyle = UserCommonStyles();
  const dispatch = useDispatch();
  const [cardNumber, setCardNumber] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [cvc, setCvc] = useState('');
  let userData = localStorage.getItem("userData");
  userData = userData ? JSON.parse(userData) : {};
  const [userInfo] = useState(JSON.parse(JSON.stringify(userData)));
  const [sellerInfo, setSellerInfo] = useState<ICreateSellerProfile>();
  const [enableSaveButton, setEnableSaveButton] = useState(false);
  const [timeOutState, setTimeOutState] = useState(null);
  const [locationPredictions, setLocationPredictions] = useState({
    predictions: locationPrediction.predictions,
  });
  const [taxIdError, setTaxError] = useState<string>("");
  const [zipCodeError, setZipCodeError] = useState<string>("");
  const [dayCodeError, setDayCodeError] = useState<string>("");
  const [monthCodeError, setMonthCodeError] = useState<string>("");
  const [yearCodeError, setYearCodeError] = useState<string>("");
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<ICreateSellerProfile>({
    resolver: yupResolver(createSellerProfileValidationSchema(translation)),
  });
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  const [openDialog, setOpenDialog] = useState(false);
  

  const handleCloseDialog = async (token) => {
    setOpenDialog(false);
    setEnableSaveButton(true);
    if (token) {
      setSellerInfo({
        ...sellerInfo,
        [token]: token,
      });
    const response: any = await dispatch(editSeller(sellerInfo,token));
    console.log("SAKKKKK->",response)
    if (response?.isSuccess) {
      setEnableSaveButton(false);
      toast.success(translation(response.message));
      return props.history.push(RoutingLinks.marketplace);
      //
    } else {
        alert(response?.error);
      setEnableSaveButton(false);
      // return toast.error(translation(response.message));
    //   console.log("SAK---->",response)
    //   if(response?.error != undefined){
    //     return alert((response?.error?.raw?.message != undefined) ? response?.error?.raw?.message:"Something went wrong");
    //   }else return toast.error(translation(response.message));
    }
    }else setEnableSaveButton(false);
  };
  /**
   * Updates the Textfield value in the state
   * @param event
   * @param name
   */
  const handleChange = (event: any, name: string) => {
    let target = event.target as HTMLInputElement;
    if (name === "tax_id" && !/^\d+$/.test(target?.value)) {
      return setTaxError("Tax Id is required in Number");
    }
     else {
      setTaxError("");
      setSellerInfo({
        ...sellerInfo,
        [name]: target.value,
      });
    }
  };
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setLocationPredictions((prevState) => ({
            ...prevState,
            predictions: [],
          }));
        }
      }

      /**
       * Bind the event listener
       */
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        /**
         * Unbind the event listener on clean up
         */
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  /**
   * auto fill seller data
   */
  const autoFillSellerData = useCallback(async () => {
    if (userInfo) {
      setSellerInfo({
        userId: userInfo.id,
        firstname: userInfo.first_name,
        lastname: userInfo.last_name,
        email: userInfo.email,
        phone_number: userInfo.phone_number,
        location: userInfo.address,
        latitude: userInfo.latitude,
        longitude: userInfo.longitude,
        description: userInfo.description,
        image: userInfo.profile_image ? userInfo.profile_image : "",
        tax_id: null,
        imageUpdate: false,
        imageName: userInfo.profile_image
          ? userInfo.profile_image.substring(
              userInfo.profile_image.lastIndexOf("/") + 1
            )
          : "",
      });
    }
  }, [userInfo]);



  /**
   * To submit data
   * @returns
   */
  const onSubmit = async () => {
    console.log("sellerInfo :>> ", sellerInfo);
    setTaxError("");
    if (
      sellerInfo?.snn !== undefined && sellerInfo?.snn !== "" &&
      sellerInfo?.address !== undefined && sellerInfo?.address !== "" &&
      sellerInfo?.state !== undefined && sellerInfo?.state !== "" &&
      sellerInfo?.city !== undefined && sellerInfo?.city !== "" &&
      sellerInfo?.country !== undefined && sellerInfo?.country !== "" &&
      sellerInfo?.zip_code !== undefined && sellerInfo?.zip_code !== "" &&
      sellerInfo?.day !== undefined && sellerInfo?.day !== "" &&
      sellerInfo?.month !== undefined && sellerInfo?.month !== "" &&
      sellerInfo?.year !== undefined && sellerInfo?.year !== "" &&
      cardNumber !== "" &&
      expiryDate !== undefined && cvc !== ""
    ) {
      //
      try {
        // Make the token creation request to your server
        const [expiryMonth, expiryYear] = expiryDate.split('/');
        const response = await axios.post(
          'https://api.stripe.com/v1/tokens',
          new URLSearchParams({
            'card[number]': cardNumber,
            'card[exp_month]': expiryMonth.trim(),
            'card[exp_year]': expiryYear.trim(),
            'card[cvc]': cvc,
            'card[currency]': 'usd',
          }),
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ""}`,
            },
          }
        );
  
        console.log('Token Created:', response.data.id);
       
        return handleCloseDialog(response.data.id); // Contains the token to use later
      } catch (error) {
        
        console.log(JSON.stringify(error));
        if (axios.isAxiosError(error)) {
          if (error.response) {
            // Server responded with a status code outside the 2xx range
            const errorDetails = error.response.data;
            console.error('Stripe Error:', errorDetails);
        
            // Extract meaningful message
            const message = errorDetails.error?.message || 'An error occurred while processing your payment.';
        
            // Show error to user
            alert(message);
          } else alert("Something went wrong");
        } else alert("Something went wrong");
        
      }
      //
    } else {
      setEnableSaveButton(false);
      toast.info("Please fill all required fields!");
    }
  };
  useEffect(() => {
    autoFillSellerData();
  }, [autoFillSellerData]);

  return (
    <Box>
      <StripeCardDetailsModalWrapper open={openDialog} onClose={handleCloseDialog} />
      <Grid container>
        <Grid item md={3}>
          <LeftSidebar />
          {/* <SocialIconSection /> */}
        </Grid>

        <Grid item md={6}>
          <Box className={commonStyle.p20}>
            <Typography
              variant="h6"
              className={`${commonStyle.grey} ${commonStyle.mb15} ${commonStyle.fontWeight600}`}
            >
              {translation("edit_seller_profile")}
            </Typography>
            <Box className={`${commonStyle.p20} ${commonStyle.card}`}>
              {sellerInfo && Object.keys(sellerInfo).length > 0 && (
                <form onSubmit={handleSubmit(onSubmit)} noValidate>
                  <Grid container spacing={2}>

                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {translation("fname")}
                        </Typography>
                        <TextField
                          {...register("firstname")}
                          variant="outlined"
                          className={commonStyle.w100}
                          onChange={(e) => handleChange(e, "firstname")}
                          inputProps={{ readOnly: true }}
                          value={
                            sellerInfo.firstname ? sellerInfo.firstname : ""
                          }
                        />
                        {errors && errors.firstname && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.firstname?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>

                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {translation("lname")}
                        </Typography>
                        <TextField
                          {...register("lastname")}
                          variant="outlined"
                          className={commonStyle.w100}
                          name="lastname"
                          onChange={(e) => handleChange(e, "lastname")}
                          inputProps={{ readOnly: true }}
                          value={sellerInfo.lastname ? sellerInfo.lastname : ""}
                        />
                        {errors && errors.lastname && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.lastname?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>

                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {translation("email")}
                        </Typography>
                        <TextField
                          {...register("email")}
                          variant="outlined"
                          className={commonStyle.w100}
                          defaultValue={
                            sellerInfo.email ? sellerInfo.email : ""
                          }
                          inputProps={{ readOnly: true }}
                        />
                        {errors && errors.email && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.email?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>

                    <Grid item md={6}>
                      <Box className={commonStyle.commonInput}>
                        <Typography className={commonStyle.labelCommonInput}>
                          {translation("contact")}
                        </Typography>
                        <TextField
                          {...register("phone_number")}
                          variant="outlined"
                          className={commonStyle.w100}
                          name="phone_number"
                          onChange={(e) => handleChange(e, "phone_number")}
                          value={
                            sellerInfo.phone_number
                              ? sellerInfo.phone_number
                              : ""
                          }
                          inputProps={{ readOnly: true, maxLength: 10 }}
                        />
                        {errors && errors.phone_number && (
                          <span className={commonStyle.errorMsg}>
                            {errors?.phone_number?.message}
                          </span>
                        )}
                      </Box>
                    </Grid>

                     {/* Address Section */}
  
                  <Grid item md={12}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("address")}
                      </Typography>
                      <TextField
                        {...register("address")}
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "address")}
                        value={sellerInfo.address ? sellerInfo.address : ""}
                      />
                      {errors && errors.address && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.address?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
  
                  <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("city")+"*"}
                      </Typography>
                      <TextField
                        {...register("city")}
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "city")}
                        value={sellerInfo.city ? sellerInfo.city : ""}
                      />
                      {errors && errors.city && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.city?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
  
                  <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("state")+"*"}
                      </Typography>
                      <TextField
                        {...register("state")}
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "state")}
                        value={sellerInfo.state ? sellerInfo.state : ""}
                      />
                      {errors && errors.state && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.state?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
  
                  <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("zip_code")+"*"}
                      </Typography>
                      <TextField
                        {...register("zip_code")}
                        variant="outlined"
                        className={commonStyle.w100}
                        type="number"
                        onChange={(e) => handleChange(e, "zip_code")}
                        value={sellerInfo.zip_code ? sellerInfo.zip_code : ""}
                      />
                      {errors && errors.zip_code && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.zip_code?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
  {/* Country */}
  <Grid item lg={12} md={12} sm={12}>
                  
                  {/* Gender Selection Container //////////  */}
                  <Box
                    className={`${commonStyle.fontWeight400} ${commonStyle.f_family_Roboto} ${commonStyle.font18}`}
                    sx={{
                      width: "85%",
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                      marginLeft: "auto",
                      marginRight: "auto",
                      marginBottom: "15px",
                    }}
                  >
                    <Button
                      sx={{
                        maxWidth: "220px",
                        width: "100%",
                        minWidth: "150px",
                        height: "43px",
                        backgroundColor:
                          gender === "all" ? "#c7eef0" : "#e0e0e0",
                        color: gender === "all" ? "#01B4BC" : "#4C4C4C",
                        borderRadius: "8px",
                      }}
                      onClick={() => setGender("all")}
                    >
                      All
                    </Button>
                    <Button
                      sx={{
                        maxWidth: "220px",
                        width: "100%",
                        minWidth: "150px",
                        height: "43px",
                        backgroundColor:
                          gender === "men" ? "#c7eef0" : "#e0e0e0",
                        color: gender === "men" ? "#01B4BC" : "#4C4C4C",
                        borderRadius: "8px",
                      }}
                      onClick={() => setGender("men")}
                    >
                      Men
                    </Button>
                    <Button
                      sx={{
                        maxWidth: "220px",
                        width: "100%",
                        minWidth: "150px",
                        height: "43px",
                        backgroundColor:
                          gender === "women" ? "#c7eef0" : "#e0e0e0",
                        color: gender === "women" ? "#01B4BC" : "#4C4C4C",
                        borderRadius: "8px",
                      }}
                      onClick={() => setGender("women")}
                    >
                      Women
                    </Button>
                  </Box>
                  {validationErrors && validationErrors.genderError && (
                    <span className={`${commonStyle.errorMsg}`}>
                      {validationErrors.genderError}
                    </span>
                  )}
                </Grid>
  {/* Country */}
                  <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("country")+"*"}
                      </Typography>
                      <TextField
                        {...register("country")}
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "country")}
                        value={sellerInfo.country ? sellerInfo.country : ""}
                      />
                      {errors && errors.country && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.country?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
                  <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("SSN(last 4 Digits)")+"*"}
                      </Typography>
                      <TextField
                        {...register("snn")}
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Allow only numeric values and limit length to 4
                          if (/^\d*$/.test(value) && value.length <= 4) {
                            handleChange(e, "snn");
                          }
                        }}
                        value={sellerInfo.snn || ""}
                      />
                      {errors && errors.country && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.country?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
   {/* Address Section */}
                  {/* Date of Birth Section */}
                  <Grid item md={12}>
                  <Typography
              variant="h6"
              className={commonStyle.labelCommonInput}
            >
              {translation("dob")+"*"}
            </Typography>
                  </Grid>
  
                 
  
                  <Grid item md={4}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("month")}
                      </Typography>
                      <TextField
                        {...register("month")}
                        variant="outlined"
                        type="number"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "month")}
                        value={sellerInfo.month ? sellerInfo.month : ""}
                      />
                      {errors && errors.month && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.month?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
  
                  <Grid item md={4}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("day")}
                      </Typography>
                      <TextField
                        {...register("day")}
                        variant="outlined"
                        type="number"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "day")}
                        value={sellerInfo.day ? sellerInfo.day : ""}
                      />
                      {errors && errors.day && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.day?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
                  
                  <Grid item md={4}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("year")}
                      </Typography>
                      <TextField
                        {...register("year")}
                        variant="outlined"
                        type="number"
                        className={commonStyle.w100}
                        onChange={(e) => handleChange(e, "year")}
                        value={sellerInfo.year ? sellerInfo.year : ""}
                      />
                      {errors && errors.year && (
                        <span className={commonStyle.errorMsg}>
                          {errors?.year?.message}
                        </span>
                      )}
                    </Box>
                  </Grid>
                 {/* Date of Birth Section */}
                    {/* Date of Birth Section */}
                    <Grid item md={12}>
                  <Typography
              variant="h6"
              className={commonStyle.labelCommonInput}
            >
              {translation("Card Details")}
            </Typography>
                  </Grid>
  
                  <Grid item md={12}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("Card Number*")}
                      </Typography>
                      <TextField
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => setCardNumber(e.target.value)}
                        value={cardNumber ? cardNumber : ""}
                        inputProps={{ maxLength: 16 }}
                      />
                    </Box>
                  </Grid>
  
                  <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("Exp Date(MM/YY)")+"*"}
                      </Typography>
                      <TextField
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => setExpiryDate(e.target.value)}
                        value={expiryDate ? expiryDate : ""}
                      />
                    </Box>
                  </Grid>
  
                  <Grid item md={6}>
                    <Box className={commonStyle.commonInput}>
                      <Typography className={commonStyle.labelCommonInput}>
                        {translation("CVV")+"*"}
                      </Typography>
                      <TextField
                       
                        variant="outlined"
                        className={commonStyle.w100}
                        onChange={(e) => setCvc(e.target.value)}
                        value={cvc ? cvc : ""}
                      />
                    </Box>
                  </Grid>
                 
                 {/* Date of Birth Section */}
                 
</Grid>
                  <Box className={commonStyle.flexCenter}>
                    <Box
                      className={`${commonStyle.mr10} ${commonStyle.blueBtn}`}
                    >
                      {/* <CommonButton label="Save & Continue" /> */}
                      <Button
                        disabled={enableSaveButton}
                        onClick={onSubmit}
                      >
                        {translation("save")} {enableSaveButton ? <ClipLoader /> : null} 
                      </Button>
                    </Box>
                    <Box
                      className={`${commonStyle.mr10} ${commonStyle.greyBtn}`}
                    >
                      {/* <CommonButton label="Cancel" /> */}
                      <Button onClick={autoFillSellerData}>
                        {translation("cancel")}
                      </Button>
                    </Box>
                  </Box>
                </form>
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item md={3}>
          <RightSidebar />
        </Grid>
      </Grid>
    </Box>
  );
};

export default EditSeller;
